import type { UserTraits } from '@blueshift-ui/analytics/dist/types/user-traits';

import getRoleTraits from './get-role-traits';
import getStudentTraits from './get-student-traits';

function getUserTraits(labUser?: any): UserTraits | undefined {
  if (!labUser) {
    return undefined;
  }

  return {
    ...getRoleTraits(labUser),
    email: labUser.email,
    first_name: labUser.firstName,
    id: labUser.entityId,
    jurisdiction_id: labUser.jurisdictionId,
    last_name: labUser.lastName,
    product_state: labUser.productState,
    role: labUser.role,
    sales_group_ids: labUser.salesGroupIds,
    students: labUser.students?.map(getStudentTraits) ?? [],
    user_id: labUser.id,
  };
}

export default getUserTraits;
